<template lang="pug">
    div.main
        nav
            div.logo
                img(src="logo.png")
            ul
                router-link(:to={name: "home"},tag="li")
                    fa(icon="home")
                    | Dashboard
                router-link(:to={name: "level-stats"},tag="li")
                    fa(icon="chart-pie")
                    | Level Stats
                //- router-link(:to={name: "timeline"},tag="li")
                //-     fa(icon="clock")
                //-     | Timeline
                //- router-link(:to={name: "player-stats"},tag="li")
                //-     fa(icon="users")
                //-     | Players
                //- router-link(:to={name: "game-stats"},tag="li")
                //-     fa(icon="gamepad")
                //-     | Playtime Stats
                router-link(:to={name: "conversions"},tag="li")
                    fa(icon="shopping-cart")
                    | Conversions
                router-link(:to={name: "ab-tests"},tag="li")
                    fa(icon="flask")
                    | AB Tests
                router-link(:to={name: "countries"},tag="li")
                    fa(icon="flag")
                    | Countries
            .bottomBar
              a(href="#", @click="logout")
                fa(icon="times")
        div.content
            router-view
</template>

<script>
import AuthService from "@/services/auth";

export default {
    methods: {
        logout() {
            AuthService.clearAuthToken();
            this.$router.push({ name: "login" });
        },
    },
};
</script>

<style lang="scss" scoped>
.main {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: grid;
    grid-template-columns: 250px 1fr;

    > nav {
        user-select: none;
        background: #ebedf0;
        display: grid;
        grid-template-rows: auto 1fr auto;

        .bottomBar {
            padding: 10px;

            a {
                color: #333;
                text-transform: uppercase;
            }
        }

        > .logo {
            padding: 20px;
            background: #d8dbe0;
            width: 100%;
            align-self: center;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 60px;
            img {
                width: 80%;
            }
        }

        > ul {
            margin-top: 20px;

            > li {
                color: #95989f;
                background: transparent;
                padding: 10px 20px;
                text-transform: uppercase;

                transition: background-color 0.2s ease-in-out;
                display: grid;
                grid-template-columns: 30px 1fr;
                align-items: center;

                &.router-link-exact-active {
                    color: #55585f;
                    background-color: rgba(#000f15, 0.05);
                }
                &:not(.router-link-exact-active) {
                    cursor: pointer;
                    &:hover {
                        background-color: rgba(#000f15, 0.02);
                    }
                }
            }
        }
    }

    > .content {
        background: #fff;
        overflow-y: auto;
        padding: 50px;

        color: #b5b9bf;
    }
}

@media (max-width: 1000px) {
    .main {
        display: flex;
        flex-direction: column;

        position: relative;

        > nav {
            font-size: 12px;
            padding-left: 10px;
            grid-template-columns: 1fr auto;
            grid-template-rows: auto;
            align-items: center;

            > .bottomBar svg {
                font-size: 14px;
            }

            > .logo {
                display: none !important;
            }
            > ul {
                display: flex;
                margin: 0;
                > li {
                    overflow: hidden;
                    width: 25px;
                    padding: 5px;
                    font-size: 1.4em;
                }
            }
        }

        > .content {
            padding: 10px;
        }
    }
}
</style>
